'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _frontendUtils = require('@import/frontend-utils');
var _validationUtils = require('@import/validation-utils');
var ValidationUtils = _interopRequireWildcard(_validationUtils);
var _BaseApi2 = require('../BaseApi');
var _BaseApi3 = _interopRequireDefault(_BaseApi2);
var _ParameterError = require('../ParameterError');
var _ParameterError2 = _interopRequireDefault(_ParameterError);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var AuthApi = function (_BaseApi) {
  (0, _inherits3.default)(AuthApi, _BaseApi);
  function AuthApi() {
    (0, _classCallCheck3.default)(this, AuthApi);
    return (0, _possibleConstructorReturn3.default)(this, (AuthApi.__proto__ || Object.getPrototypeOf(AuthApi)).call(this, _frontendUtils.endpoints.apiBaseUrl));
  }

  /**
   * Signs in user with provided credentials.
   * @param  {String}  username             User's login, used to authenticate.
   * @param  {String}  password             User's password, used to authenticate.
   * @param  {Object}  additionalUrlParams  Object with parameters that will be added as query parameters to the URL.
   * @param  {Boolean} remember             Value indicating if the response cookie should be long-lived one.
   * @return {Promise}                      Promise resolves with no data, if user was successfully logged in. Otherwise promise rejects with ParameterError or ResponseError object.
   */

  (0, _createClass3.default)(AuthApi, [{
    key: 'signIn',
    value: function signIn(username, password) {
      var additionalUrlParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var remember = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      if (!ValidationUtils.isNonEmptyOrBlankString(username)) {
        return Promise.reject(new _ParameterError2.default('username', username, 'non-blank string.'));
      }
      if (!ValidationUtils.isNonEmptyOrBlankString(password)) {
        return Promise.reject(new _ParameterError2.default('password', password, 'non-blank string.'));
      }
      if (!ValidationUtils.isObject(additionalUrlParams)) {
        return Promise.reject(new _ParameterError2.default('additionalUrlParams', additionalUrlParams, 'JS object.'));
      }
      if (!ValidationUtils.isBoolean(remember)) {
        return Promise.reject(new _ParameterError2.default('remember', remember, 'boolean value.'));
      }
      return this.makeRequest({
        method: 'POST',
        url: 'auth/login',
        queryParameters: additionalUrlParams,
        body: 'username=' + encodeURIComponent(username) + '&password=' + encodeURIComponent(password) + '&remember=' + encodeURIComponent(remember),
        contentType: 'application/x-www-form-urlencoded; charset=utf-8'
      });
    }

    /**
     * Signs out currently logged in user.
     * @return {Promise} Promise resolves with no data, if user was successfully logged out. Otherwise promise rejects with ResponseError object.
     */
  }, {
    key: 'signOut',
    value: function signOut() {
      return this.makeRequest({
        method: 'POST',
        url: 'auth/logout'
      });
    }

    /**
     * Gets for the server details of currently authenticated user.
     * @return {Promise} Promise resolves with user details object, if query finished successfully. Otherwise promise rejects with ResponseError object.
     */
  }, {
    key: 'currentUser',
    value: function currentUser() {
      return this.makeRequest({
        method: 'GET',
        url: 'auth/currentuser'
      });
    }

    /**
     * Obtains already created API key from the server.
     * @param  {String} password Password to user's account, optional for non-admin users.
     * @return {Promise}         Promise resolves with the API key, if request was successful. Otherwise promise rejects with ParameterError or ResponseError object.
     */
  }, {
    key: 'getApiKey',
    value: function getApiKey(password) {
      if (!ValidationUtils.isUndefinedOr(ValidationUtils.isNonEmptyOrBlankString, password)) {
        return Promise.reject(new _ParameterError2.default('password', password, 'non-blank string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: 'auth/apikeyadmin',
        queryParameters: {
          password: password
        }
      });
    }

    /**
     * Creates new API key on the server.
     * @param  {String} password Password to user's account, optional for non-admin users.
     * @return {Promise}         Promise resolves with the API key, if request was successful. Otherwise promise rejects with ParameterError or ResponseError object.
     */
  }, {
    key: 'createApiKey',
    value: function createApiKey(password) {
      if (!ValidationUtils.isUndefinedOr(ValidationUtils.isNonEmptyOrBlankString, password)) {
        return Promise.reject(new _ParameterError2.default('password', password, 'non-blank string.'));
      }
      return this.makeRequest({
        method: 'POST',
        url: 'auth/apikeyadmin',
        body: {
          password: password
        }
      });
    }

    /**
     * Creates a new user account.
     * @param  {String} email    Email address for new user
     * @param  {String} password Password for new user
     * @return {Promise}         Promise resolves to an object containing the new user's email, guid, orgGuid, roles and username, if successful.
     */
  }, {
    key: 'createUser',
    value: function createUser(email, password) {
      if (!ValidationUtils.isUndefinedOr(ValidationUtils.isNonEmptyOrBlankString, email)) {
        return Promise.reject(new _ParameterError2.default('email', email, 'non-blank string.'));
      }
      if (!ValidationUtils.isUndefinedOr(ValidationUtils.isNonEmptyOrBlankString, password)) {
        return Promise.reject(new _ParameterError2.default('password', password, 'non-blank string.'));
      }
      return this.makeRequest({
        method: 'POST',
        url: 'auth/new',
        body: 'email=' + encodeURIComponent(email) + '&password=' + encodeURIComponent(password),
        contentType: 'application/x-www-form-urlencoded; charset=utf-8'
      });
    }

    /**
     * Requests a password reset.
     * @param  {String} username Username or email of an existing user account
     * @return {Promise}         Returns a Promise which resolves to True when successful
     */
  }, {
    key: 'requestPasswordReset',
    value: function requestPasswordReset(username) {
      if (!ValidationUtils.isUndefinedOr(ValidationUtils.isNonEmptyOrBlankString, username)) {
        return Promise.reject(new _ParameterError2.default('username', username, 'non-blank string.'));
      }
      return this.makeRequest({
        method: 'POST',
        url: 'auth/reset-request',
        body: 'username=' + encodeURIComponent(username),
        contentType: 'application/x-www-form-urlencoded; charset=utf-8'
      });
    }

    /**
     * Resets password.
     * @param  {String} resetId  GUID to authenticate the reset request.
     * @param  {String} username Username or email of an existing user account.
     * @param  {String} password New password.
     * @return {Promise}         Returns a Promise. No response when successful, returns an error object otherwise.
     */
  }, {
    key: 'resetPassword',
    value: function resetPassword(resetId, username, password) {
      if (!ValidationUtils.isGuid(resetId)) {
        return Promise.reject(new _ParameterError2.default('resetId', resetId, 'guid string.'));
      }
      if (!ValidationUtils.isUndefinedOr(ValidationUtils.isNonEmptyOrBlankString, username)) {
        return Promise.reject(new _ParameterError2.default('username', username, 'non-blank string.'));
      }
      if (!ValidationUtils.isUndefinedOr(ValidationUtils.isNonEmptyOrBlankString, password)) {
        return Promise.reject(new _ParameterError2.default('password', password, 'non-blank string.'));
      }
      return this.makeRequest({
        method: 'POST',
        url: 'auth/reset-execute',
        body: 'id=' + encodeURIComponent(resetId) + '&username=' + encodeURIComponent(username) + '&password=' + encodeURIComponent(password),
        contentType: 'application/x-www-form-urlencoded; charset=utf-8'
      });
    }

    /**
     * Checks wheter a username is available.
     * @param  {String} username.
     * @return {Promise} Promise resolves, if request was successful. Otherwise promise rejects with ParameterError or ResponseError object.
     */
  }, {
    key: 'checkUsername',
    value: function checkUsername(username) {
      if (!ValidationUtils.isUndefinedOr(ValidationUtils.isNonEmptyOrBlankString, username)) {
        return Promise.reject(new _ParameterError2.default('username', username, 'non-blank string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: 'auth/username-available',
        queryParameters: {
          username: username
        }
      });
    }
  }]);
  return AuthApi;
}(_BaseApi3.default);
exports.default = AuthApi;